module.exports = __webpack_public_path__ + "img/TOP EMILY GONNA CUBA.45c427da.jpg";